import { Control, Label, Field, Input, Icon } from 'rbx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import './styles.scss'

export const TextFieldWithPlus = ({ name, label, value, onChange, onClick, ...other }) => {
  return (
    <>
      {(label) && <Label>{label}</Label>}
      <Field>
        <Control iconRight>
          <Input 
            name={name}
            value={value}
            onChange={onChange}
            {...other}
          />
          <Icon color="black" align="right" onClick={onClick} title="Adicionar">
            <FontAwesomeIcon icon={faPlusCircle} />
          </Icon>
        </Control>
      </Field>
    </>
  )
}
